import React, { Component } from "react";

class NotificationToast extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: false, exiting: false };
    this.timer = null;
    this.exitTimer = null;
  }

  startTimer() {
    const duration = this.props.duration || 30000;
    this.timer = setTimeout(() => {
      this.setState({ exiting: true });
      this.exitTimer = setTimeout(() => {
        this.setState({ visible: false, exiting: false });
        if (this.props.onDismiss) this.props.onDismiss();
      }, 400);
    }, duration);
  }

  componentDidMount() {
    if (this.props.message) {
      this.setState({ visible: true, exiting: false });
      this.startTimer();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.message && this.props.message !== prevProps.message) {
      clearTimeout(this.timer);
      clearTimeout(this.exitTimer);
      this.setState({ visible: true, exiting: false });
      this.startTimer();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
    clearTimeout(this.exitTimer);
  }

  dismiss() {
    clearTimeout(this.timer);
    clearTimeout(this.exitTimer);
    this.setState({ exiting: true });
    setTimeout(() => {
      this.setState({ visible: false, exiting: false });
      if (this.props.onDismiss) this.props.onDismiss();
    }, 400);
  }

  render() {
    if (!this.state.visible || !this.props.message) return null;

    const type = this.props.type || "success";
    const configs = {
      success: { bg: "#f0fdf4", border: "#bbf7d0", icon: "ni-check-circle-fill", iconColor: "#16a34a", titleColor: "#15803d" },
      error:   { bg: "#fef2f2", border: "#fecaca", icon: "ni-cross-circle-fill",  iconColor: "#dc2626", titleColor: "#b91c1c" },
      info:    { bg: "#eff6ff", border: "#bfdbfe", icon: "ni-info-fill",          iconColor: "#2563eb", titleColor: "#1d4ed8" },
    };
    const c = configs[type] || configs.success;
    const { actions } = this.props;

    return (
      <div
        style={{
          backgroundColor: c.bg,
          border: `1px solid ${c.border}`,
          borderRadius: 12,
          padding: "16px 20px",
          boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.1)",
          display: "flex",
          alignItems: "flex-start",
          gap: 12,
          animation: this.state.exiting
            ? "ncToastSlideOut 0.4s ease forwards"
            : "ncToastSlideIn 0.4s cubic-bezier(0.16,1,0.3,1) forwards",
        }}
      >
        <style>{`
          @keyframes ncToastSlideIn {
            from { opacity: 0; transform: translateX(100%) scale(0.95); }
            to   { opacity: 1; transform: translateX(0) scale(1); }
          }
          @keyframes ncToastSlideOut {
            from { opacity: 1; transform: translateX(0) scale(1); }
            to   { opacity: 0; transform: translateX(100%) scale(0.95); }
          }
        `}</style>

        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            backgroundColor: c.iconColor + "22",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <em className={`icon ni ${c.icon}`} style={{ fontSize: 18, color: c.iconColor }}></em>
        </div>

        <div style={{ flex: 1 }}>
          <div
            style={{
              fontWeight: 700,
              fontSize: 14,
              color: c.titleColor,
              marginBottom: 4,
              lineHeight: 1.3,
            }}
          >
            {this.props.title || (type === "success" ? "Success" : type === "error" ? "Error" : "Info")}
          </div>
          <div
            style={{
              fontSize: 13,
              color: "#475569",
              lineHeight: 1.5,
              marginBottom: actions && actions.length ? 10 : 0,
            }}
          >
            {this.props.message}
          </div>

          {actions && actions.length ? (
            <div style={{ display: "flex", gap: 8 }}>
              {actions.map((action, i) => (
                <button
                  key={i}
                  type="button"
                  onClick={() => action.onClick()}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    padding: "6px 10px",
                    fontSize: 12,
                    fontWeight: 600,
                    borderRadius: 10,
                    border: action.variant === "danger" ? "1px solid #fecaca" : "1px solid #e0e7ff",
                    background: action.variant === "danger" ? "#fff1f2" : "#f8faff",
                    color: action.variant === "danger" ? "#dc2626" : "#4f46e5",
                    cursor: "pointer",
                  }}
                >
                  {action.icon ? <em className={`icon ni ${action.icon}`}></em> : null}
                  {action.label}
                </button>
              ))}
            </div>
          ) : null}
        </div>

        <button
          type="button"
          onClick={() => this.dismiss()}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 2,
            color: "#94a3b8",
            fontSize: 16,
            lineHeight: 1,
            flexShrink: 0,
            marginTop: 2,
          }}
        >
          <em className="icon ni ni-cross"></em>
        </button>
      </div>
    );
  }
}

export default NotificationToast;
